import React from 'react';
import { Header, Button } from 'semantic-ui-react';

export default function PostSubmissionMessage({ message, buttonName, onReset }) {
  return (
    <div className="post-form-submission">
      <Header as="h4">{message}</Header>
      <Button primary onClick={onReset}>
        {buttonName}
      </Button>
    </div>
  );
}
